import { useSWRConfig } from 'swr';
import { useParams } from 'react-router-dom';
import { postFetcher } from '@/api/fetchers';
import { displayError } from '@/utils/error/errorHandler';

export default function useApproveAbsence() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const approveAbsence = async (id: number) => {
    try {
      if (employeeId === undefined)
        throw new Error('employeeId is undefined. Check URL.');

      await postFetcher(`/employees/${employeeId}/absences/${id}/confirmation`);

      await mutate(`/employees/${employeeId}/absences`);
    } catch (err) {
      displayError(err);
    }
  };

  return {
    approveAbsence,
  };
}
